export class PageContentManual {
    public static contentLIst: Map<string, string> = new Map<string, string>([
      ['eReturn Usermanual', 'ই-রিটার্ন ইউজার ম্যানুয়াল']  
    ]);
  
    public static selectedLanguageCode = '0';
  
  }
  
  
  export const languageList = [
    {code: '0', label: 'বাংলা'},
    {code: '1', label: 'English'}];
  
  export function content(text: string) {
    if (PageContentManual.selectedLanguageCode === '1') {
      return text;
    } else {
      return PageContentManual.contentLIst.has(text) ? PageContentManual.contentLIst.get(text) : text;
    }
  }
  
  